const singleVariantProducts = [
  "emma-diamond-pillow",
  "emma-foam-pillow",
  "emma-pillow-bundle",
  "emma-airgrid-pillow"
];

class BlockCrossSell extends HTMLElement {
  constructor() {
    super();

    this.props = {
      description: "",
      subtitle: "",
      mainProduct: {},
      mainProductVariant: {},
      mainProductVariants: [],
      crossSellProduct: {},
      crossSellProductVariants: [],
    };

    this.state = {
      quantity: 1,
      status: "idle",
      currentMainProductVariant: {},
      currentCrossSellProductVariant: {},
    };
  }

  async connectedCallback() {
    this.initProps();
    this.initState();

    await this.wait(1000);

    updateCrossSellVariantTitle();

    this.render(this.getRenderData());
    this.attachCallback();
    this.querySelector(".animate-skeleton")?.classList?.add("hidden");

    ProductPageStore.subscribe((event) => {
      this.handleMainProductVariantChange(event.detail.currentVariant);
    });
  }

  initProps() {
    this.props.description = this.getAttribute(":description");
    this.props.subtitle = this.getAttribute(":subtitle");
    this.props.mainProduct = JSON.parse(this.getAttribute(":mainProduct"));
    this.props.mainProductVariant = JSON.parse(
      this.getAttribute(":mainProductVariant")
    );
    this.props.mainProductVariants = JSON.parse(
      this.getAttribute(":mainProductVariants")
    );
    this.props.crossSellProduct = JSON.parse(
      this.getAttribute(":crossSellProduct")
    );
    this.props.crossSellProductVariants = JSON.parse(
      this.getAttribute(":crossSellProductVariants")
    );
  }

  initState() {
    this.state = {
      ...this.state,
      currentMainProductVariant: this.props.mainProductVariant,
      currentCrossSellProductVariant: this.getMatchedVariantSize(
        this.props.mainProductVariant
      ),
    };
  }

  attachCallback() {
    this.querySelector("cross-sell-item-quantity").updateState =
      this.updateState.bind(this);
    this.querySelector("cross-sell-item-add-button").updateState =
      this.updateState.bind(this);
    this.querySelectorAll("cross-sell-drawer-button").forEach(
      (button) =>
      (button.handleOpenCrossSellDrawerFunction =
        this.handleCrossSellDrawerOpen.bind(this))
    );
  }

  handleCrossSellDrawerOpen() {
    window.eventBus.publish("cross-sell-drawer:open", {
      title: this.props.crossSellProduct.title.replace(" - BambooWeave", ""),
      subtitle: this.props.subtitle,
      drawerDescription: this.shadowRoot.querySelector(
        "cross-sell-drawer-description"
      ).innerHTML,
      image: this.props.crossSellProduct.featured_image,
      link: "/products/" + this.props.crossSellProduct.handle,
      primaryButton: {
        text: "제품 보러가기",
        onClick: (state, closeDrawer) => {
          window.open(state.link, "_blank");
          closeDrawer();
        },
      },
      secondaryButton: {
        text: "쇼핑 계속하기",
        onClick: (state, closeDrawer) => {
          closeDrawer();
        },
      },
    });
  }
 checkPriceVaries(product) {
  const prices = product.map(v => v.price);
  return new Set(prices).size > 1;
}
  getRenderData() {
    const result = {};
    result.hasMatchedVariantSize = this.state.currentCrossSellProductVariant;
    result.available = this.state.currentCrossSellProductVariant?.available;
    result.title = this.props.crossSellProduct.title.replace(
      " - BambooWeave",
      ""
    );
    result.price = 
      (this.state.currentCrossSellProductVariant?.price / 100) *
      this.state.quantity
  
    result.compareAtPrice = 
      (this.state.currentCrossSellProductVariant?.compare_at_price / 100) * this.state.quantity

    result.isDiscounted =
      this.state.currentCrossSellProductVariant?.compare_at_price >
      this.state.currentCrossSellProductVariant?.price;
    result.variantTitle = this.state.currentCrossSellProductVariant?.title
      ?.split("(")?.[0]
      ?.trim();
    result.description = this.props.description;
    result.productLink = "/products/" + this.props.crossSellProduct.handle;
    result.imageSrc = this.props.crossSellProduct.featured_image;
    result.discountPercentage = Math.round(
      ((this.state.currentCrossSellProductVariant?.compare_at_price -
        this.state.currentCrossSellProductVariant?.price) *
        100) /
      this.state.currentCrossSellProductVariant?.compare_at_price
    );
    result.quantity = this.state.quantity;
    result.status = this.state.status;
    result.isPillow = singleVariantProducts.includes(this.props.crossSellProduct.handle) || this.props.crossSellProduct.tags.includes("pillow");
    result.priceVaries = this.checkPriceVaries(this.props.crossSellProductVariants, "props");
    return result;
  }



  getMatchedVariantSize(mainProductVariant) {
    if (
      singleVariantProducts.includes(this.props.crossSellProduct.handle) ||
      this.props.crossSellProduct.tags.includes("pillow")
    ) {
      return this.props.crossSellProductVariants[0];
    }

    const size = mainProductVariant?.title
      ?.split("(")?.[0]
      ?.trim()
      ?.toLowerCase();
    if (!size) return;

    const regex = new RegExp(String.raw`^${size}$`, "i");
    return this.props.crossSellProductVariants.find((variant) =>
      regex.test(variant?.title?.split("(")?.[0]?.trim()?.toLowerCase())
    );
  }

  hideCrossSell() {
    this.updateState({
      currentMainProductVariant: null,
      currentCrossSellProductVariant: null,
      status: "idle",
    });
  }

  handleMainProductVariantChange(mainProductVariant) {
    const variant = this.getMatchedVariantSize(mainProductVariant);

    this.updateState({
      currentMainProductVariant: mainProductVariant,
      currentCrossSellProductVariant: variant,
      status: variant?.available ? this.state.status : "idle",
    });
  }

  updateState(updates) {
    this.state = { ...this.state, ...updates };
    updateCrossSellVariantTitle();
    this.render(this.getRenderData());
    this.attachCallback();
    this.notifyStateChange();
  }

  notifyStateChange() {
    const event = new CustomEvent("update", {
      detail: {
        ...this.state,
        crossSellProductId: this.props.crossSellProduct.id,
      },
    });
    this.dispatchEvent(event);
  }

  getAddToCartData() {
    const result = {};
    result.isAdded = this.state.status === "active";
    result.quantity = Number(this.state.quantity);
    result.variantId = this.state.currentMainProductVariant?.id;
    result.crossSellVariantId = this.state.currentCrossSellProductVariant?.id;
    result.status = this.state.status;
    return result;
  }

  render(data) {
    this.innerHTML = `
      <cross-sell-item class="${data.hasMatchedVariantSize ? "" : "hidden"}">
        <div class="flex items-center gap-3">
          <img src="${data.imageSrc}" width="50" height="50" class="rounded">
          <div class="flex-1">
            <cross-sell-drawer-button class="font-semibold text-[14px] block cursor-pointer ${data.status === "idle" ? "" : "text-[#FF8900]"
      }">${data.title}</cross-sell-drawer-button>
            <div class="grow gap-0 md:gap-1 mt-0 md:mt-1 flex flex-col items-start mg:items-center">
              ${!data.isPillow
        ? `<p class="text-[#55576F] text-sm ${data.variantTitle === "Default Title" ? "hidden" : ""
        }">${data.variantTitle?.split("|")?.[0]}</p>`
        : ""
      }
              <div class="flex items-center gap-2">
                ${data.isDiscounted
        ? `<p class="md:flex hidden justify-center items-center text-xs text-white font-bold max-w-max bg-[#DA1F00] rounded p-1">${data.discountPercentage}% 할인</p>`
        : ""
      }
                ${data.isDiscounted
        ? `<p class="text-sm line-through">${data.compareAtPrice.toLocaleString()}원</p>`
        : ""
      }
                <p class="text-sm ${data.isDiscounted ? "text-[#DA1F00] font-semibold" : ""}">${data.price.toLocaleString()}원</p>
              </div>
                ${data.priceVaries ? `<p class="text-[14px] text-[#2E2F3C] leading-none custom-from-tag">부터</p>`: ""}

            </div>
          </div>
    
          <cross-sell-item-add-button available="${data.available ? "available" : "unavailable"
      }" status="${data.status}"></cross-sell-item-add-button>
        </div>
        
        <p class="text-sm text-[#7F819D] mt-2">${data.description}</p>
        
        <cross-sell-drawer-button class="flex gap-1 items-center underline text-sm font-bold mt-3 cursor-pointer w-max">
          자세히 알아보기
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.36 7.52661L6.5867 3.75994C6.52472 3.69746 6.45099 3.64786 6.36975 3.61402C6.28851 3.58017 6.20137 3.56274 6.11336 3.56274C6.02535 3.56274 5.93822 3.58017 5.85698 3.61402C5.77574 3.64786 5.702 3.69746 5.64003 3.75994C5.51586 3.88485 5.44617 4.05382 5.44617 4.22994C5.44617 4.40607 5.51586 4.57503 5.64003 4.69994L8.94003 8.03328L5.64003 11.3333C5.51586 11.4582 5.44617 11.6272 5.44617 11.8033C5.44617 11.9794 5.51586 12.1484 5.64003 12.2733C5.70177 12.3363 5.7754 12.3864 5.85665 12.4207C5.9379 12.455 6.02516 12.4729 6.11336 12.4733C6.20157 12.4729 6.28882 12.455 6.37007 12.4207C6.45132 12.3864 6.52495 12.3363 6.5867 12.2733L10.36 8.50661C10.4277 8.44418 10.4817 8.36841 10.5186 8.28408C10.5556 8.19975 10.5747 8.10868 10.5747 8.01661C10.5747 7.92454 10.5556 7.83347 10.5186 7.74914C10.4817 7.66481 10.4277 7.58904 10.36 7.52661Z" fill="#2E2F3C"></path>
          </svg>
        </cross-sell-drawer-button>

        <cross-sell-item-quantity class="${data.status === "idle" ? "hidden" : ""
      }" :quantity="${data.quantity}"></cross-sell-item-quantity>
        
        <div class="h-[1px] bg-[#C5C6D3] my-5">&nbsp;</div>
      </cross-sell-item>
    `;
  }

  wait(milliseconds = 1000) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }
}

customElements.define("block-cross-sell", BlockCrossSell);

class CrossSellDrawerButton extends HTMLElement {
  constructor() {
    super();
    this.handleOpenCrossSellDrawer = this.handleOpenCrossSellDrawer.bind(this);
  }

  set handleOpenCrossSellDrawerFunction(fn) {
    this._handleOpenCrossSellDrawer = fn;
  }

  connectedCallback() {
    this.addEventListener("click", this.handleOpenCrossSellDrawer);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleOpenCrossSellDrawer);
  }

  handleOpenCrossSellDrawer() {
    if (typeof this._handleOpenCrossSellDrawer === "function") {
      this._handleOpenCrossSellDrawer();
    }
  }
}

customElements.define("cross-sell-drawer-button", CrossSellDrawerButton);

class CrossSellItemAddButton extends HTMLElement {
  constructor() {
    super();
    this.props = { status: "idle" };
  }

  connectedCallback() {
    this.initProps();
    this.render(this.getRenderData());
    this.initEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListener();
  }

  initProps() {
    this.props.status = this.getAttribute("status");
    this.props.available = this.getAttribute("available");
  }

  getRenderData() {
    const result = {};
    result.hideAddButton = this.props.status === "active";
    result.hideCloseButton = this.props.status === "idle";
    result.available = this.props.available;
    return result;
  }

  render(data) {
    this.innerHTML = `
      <button name="add" ${data.available === "available" ? "" : "disabled"
      } class="${data.hideAddButton ? "hidden" : ""
      } btn text-sm min-h-10 h-10 flex items-center p-4">
        ${data.available === "available" ? "함께 구매하기" : "품절"}
      </button>
      <button name="close" class="${data.hideCloseButton ? "hidden" : ""
      } rounded-full w-10 h-10 bg-[#F7F7F9] transform rotate-45">
        <svg width="24" height="24" viewBox="0 0 18 19" class="mx-auto" fill="#2E2F3C" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.25 9.03369H9.75V4.53369C9.75 4.33478 9.67098 4.14401 9.53033 4.00336C9.38968 3.86271 9.19891 3.78369 9 3.78369C8.80109 3.78369 8.61032 3.86271 8.46967 4.00336C8.32902 4.14401 8.25 4.33478 8.25 4.53369V9.03369H3.75C3.55109 9.03369 3.36032 9.11271 3.21967 9.25336C3.07902 9.39401 3 9.58478 3 9.78369C3 9.9826 3.07902 10.1734 3.21967 10.314C3.36032 10.4547 3.55109 10.5337 3.75 10.5337H8.25V15.0337C8.25 15.2326 8.32902 15.4234 8.46967 15.564C8.61032 15.7047 8.80109 15.7837 9 15.7837C9.19891 15.7837 9.38968 15.7047 9.53033 15.564C9.67098 15.4234 9.75 15.2326 9.75 15.0337V10.5337H14.25C14.4489 10.5337 14.6397 10.4547 14.7803 10.314C14.921 10.1734 15 9.9826 15 9.78369C15 9.58478 14.921 9.39401 14.7803 9.25336C14.6397 9.11271 14.4489 9.03369 14.25 9.03369Z" fill="#2E2F3C"></path>
        </svg>
      </button>
    `;
  }

  initEventListeners() {
    this.buttonAdd = this.querySelector('button[name="add"]');
    this.buttonClose = this.querySelector('button[name="close"]');
    this.buttonAdd.addEventListener("click", this.onAddButtonClick.bind(this));
    this.buttonClose.addEventListener(
      "click",
      this.onCloseButtonClick.bind(this)
    );
  }

  removeEventListener() {
    this.buttonAdd.removeEventListener(
      "click",
      this.onAddButtonClick.bind(this)
    );
    this.buttonClose.removeEventListener(
      "click",
      this.onCloseButtonClick.bind(this)
    );
  }

  onAddButtonClick() {
    this.updateState({ status: "active" });
  }

  onCloseButtonClick() {
    this.updateState({ status: "idle", quantity: 1 });
  }
}

customElements.define("cross-sell-item-add-button", CrossSellItemAddButton);

class CrossSellItemQuantity extends HTMLElement {
  constructor() {
    super();
    this.props = { quantity: 1 };
  }

  connectedCallback() {
    this.initProps();
    this.render(this.getRenderData());
    this.initEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListener();
  }

  initProps() {
    this.props.quantity = +this.getAttribute(":quantity");
  }

  render(data) {
    this.innerHTML = `
      <div class="flex items-center justify-between mt-4">
        <p class="text-sm font-semibold">수량</p>
        <div class="flex items-center gap-4">
          <button ${data.isDecrementDisabled ? "disabled" : ""
      }  name="decrement" class="rounded-full w-8 h-8 bg-[#F7F7F9] ${data.isDecrementDisabled
        ? "disabled:opacity-40 disabled:cursor-not-allowed"
        : ""
      }">
            <svg width="24" height="24" viewBox="0 0 18 19" class="mx-auto" fill="#2E2F3C" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.25 9.03369H3.75C3.55109 9.03369 3.36032 9.11271 3.21967 9.25336C3.07902 9.39401 3 9.58478 3 9.78369C3 9.9826 3.07902 10.1734 3.21967 10.314C3.36032 10.4547 3.55109 10.5337 3.75 10.5337H14.25C14.4489 10.5337 14.6397 10.4547 14.7803 10.314C14.921 10.1734 15 9.9826 15 9.78369C15 9.58478 14.921 9.39401 14.7803 9.25336C14.6397 9.11271 14.4489 9.03369 14.25 9.03369Z" fill="#2E2F3C"/>
            </svg>
          </button>
          <input value="${data.quantity
      }" class="pt-0 pl-3 w-12 pr-0 pb-0 text-sm cursor-default border-none bg-transparent text-center" type="number" step="1" min="1" readonly>
          <button name="increment" class="rounded-full w-8 h-8 bg-[#F7F7F9]">
            <svg width="24" height="24" viewBox="0 0 18 19" class="mx-auto" fill="#2E2F3C" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.25 9.03369H9.75V4.53369C9.75 4.33478 9.67098 4.14401 9.53033 4.00336C9.38968 3.86271 9.19891 3.78369 9 3.78369C8.80109 3.78369 8.61032 3.86271 8.46967 4.00336C8.32902 4.14401 8.25 4.33478 8.25 4.53369V9.03369H3.75C3.55109 9.03369 3.36032 9.11271 3.21967 9.25336C3.07902 9.39401 3 9.58478 3 9.78369C3 9.9826 3.07902 10.1734 3.21967 10.314C3.36032 10.4547 3.55109 10.5337 3.75 10.5337H8.25V15.0337C8.25 15.2326 8.32902 15.4234 8.46967 15.564C8.61032 15.7047 8.80109 15.7837 9 15.7837C9.19891 15.7837 9.38968 15.7047 9.53033 15.564C9.67098 15.4234 9.75 15.2326 9.75 15.0337V10.5337H14.25C14.4489 10.5337 14.6397 10.4547 14.7803 10.314C14.921 10.1734 15 9.9826 15 9.78369C15 9.58478 14.921 9.39401 14.7803 9.25336C14.6397 9.11271 14.4489 9.03369 14.25 9.03369Z" fill="#2E2F3C"/>
            </svg>
          </button>
        </div>
      </div>
    `;
  }

  getRenderData() {
    const result = {};
    result.quantity = this.props.quantity;
    result.isDecrementDisabled = this.props.quantity === 1;
    return result;
  }

  initEventListeners() {
    this.input = this.querySelector("input");
    this.plusButton = this.querySelector('button[name="increment"]');
    this.minusButton = this.querySelector('button[name="decrement"]');

    this.plusButton.addEventListener(
      "click",
      this.handleQuantityChange.bind(this)
    );
    this.minusButton.addEventListener(
      "click",
      this.handleQuantityChange.bind(this)
    );
  }

  removeEventListener() {
    this.plusButton.removeEventListener(
      "click",
      this.handleQuantityChange.bind(this)
    );
    this.minusButton.removeEventListener(
      "click",
      this.handleQuantityChange.bind(this)
    );
  }

  handleQuantityChange(event) {
    event.currentTarget.name === "increment"
      ? this.input.stepUp()
      : this.input.stepDown();
    this.updateState({ quantity: Number(this.input.value) });
  }
}

customElements.define("cross-sell-item-quantity", CrossSellItemQuantity);

class BlockProductInformation extends HTMLElement {
  constructor() {
    super();
    this.props = {
      type: "",
      title: "",
      image: "",
      handle: "",
      variants: [],
      subtitle: "",
    };
    this.state = { currentVariant: {} };
  }

  connectedCallback() {
    this.initProps();
    this.initState();
    this.render(this.getRenderData());
    if (this.props.type !== "FREEBIE") {
      ProductPageStore.subscribe((event) => {
        const currentVariant = this.getMatchedVariantSize();
        this.updateState({
          currentVariant: currentVariant
            ? currentVariant
            : this.props.variants[0],
        });

      });
    }

    this.attachCallback();
  }

  initProps() {
    this.props = {
      type: this.getAttribute(":type") ?? "",
      actionType: this.getAttribute(":action_type") ?? "drawer",
      title: this.getAttribute(":title"),
      image: this.getAttribute(":image"),
      handle: this.getAttribute(":handle"),
      variants: JSON.parse(this.getAttribute(":variants")),
      subtitle: this.getAttribute(":subtitle"),
    };
  }

  initState() {
    this.state = {
      currentVariant: this.getMatchedVariantSize()
        ? this.getMatchedVariantSize()
        : this.props.variants[0],
    };
  }

  updateState(updates) {
    this.state = { ...this.state, ...updates };
    this.render(this.getRenderData());
    this.attachCallback();
  }

  attachCallback() {
    this.querySelectorAll("cross-sell-drawer-button").forEach(
      (button) =>
      (button.handleOpenCrossSellDrawerFunction =
        this.handleCrossSellDrawerOpen.bind(this))
    );
  }

  getMatchedVariantSize() {
    const currentVariant = ProductPageStore.getState().currentVariant;
    if (!currentVariant) return this.props.variants[0];

    const size = currentVariant.title.split("(")[0].trim();
    const regex = new RegExp(String.raw`^${size}$`, "i");
    return this.props.variants.find((variant) =>
      regex.test(variant.title.split("(")[0].trim())
    );
  }

  handleCrossSellDrawerOpen() {
    if (
      this.props.actionType === "merge_pdp_tabs" &&
      document.querySelector("#joint-product-banners")
    ) {
      document
        .querySelector("#joint-product-banners")
        .scrollIntoView({ behavior: "smooth" });
      return;
    }

    window.eventBus.publish("cross-sell-drawer:open", {
      title: this.props.title.replace(" - BambooWeave", ""),
      subtitle: this.props.subtitle,
      drawerDescription: this.shadowRoot.querySelector(
        "cross-sell-drawer-description"
      ).innerHTML,
      image: this.props.image,
      link: "/products/" + this.props.handle,
      primaryButton: {
        text: "제품 보러가기",
        onClick: (state, closeDrawer) => {
          window.open(state.link, "_blank");
          closeDrawer();
        },
      },
      secondaryButton: {
        text: "쇼핑 계속하기",
        onClick: (state, closeDrawer) => {
          closeDrawer();
        },
      },
    });
  }

  getRenderData() {
    const result = {};
    result.title = this.props.title.replace(" - BambooWeave", "");
    result.price = this.state.currentVariant.price / 100;
    result.variantTitle = this.state.currentVariant.option1;
    result.compareAtPrice = this.state.currentVariant.compare_at_price / 100;
    result.image = this.props.image;
    result.isDiscounted =
      this.state.currentVariant.compare_at_price >
      this.state.currentVariant.price;
    result.discountPercentage = result.isDiscounted
      ? Math.round(
        ((this.state.currentVariant.compare_at_price -
          this.state.currentVariant.price) *
          100) /
        this.state.currentVariant.compare_at_price
      )
      : 0;
    result.isFreebie = this.props.type === "FREEBIE";
    result.isPillow = singleVariantProducts.includes(this.props.handle);
    return result;
  }

  render(data) {
    this.innerHTML = `
      <div class="flex items-center gap-3">
        <img src="${data.image
      }" width="50" height="50" class="rounded" loading="lazy" alt="">
        <div class="flex-1">
          <cross-sell-drawer-button class="font-semibold text-[14px] block cursor-pointer ">${data.title
      }</cross-sell-drawer-button>
          <div class="grow gap-0 md:gap-1 mt-0 md:mt-1 flex flex-col items-start mg:items-center">
            ${!data.isPillow
        ? `<p class="text-[#55576F] text-sm ${data.variantTitle === "Default Title" ? "hidden" : ""
        }">${data.variantTitle}</p>`
        : ""
      }
            <div class="flex items-center gap-2">
              ${data.isFreebie
        ? `
                  <p class="md:flex justify-center items-center text-xs text-white font-bold max-w-max bg-[#FF8900] rounded p-1">FREE</p>
                  <p class="text-sm line-through">${currencyFormatter.format(
          data.price
        )}</p>
                `
        : `
                  <p class="md:flex justify-center items-center text-xs text-white font-bold max-w-max bg-[#DA1F00] rounded p-1">${data.discountPercentage
        }% 할인</p>
                  <p class="text-sm ${data.isDiscounted ? "text-[#DA1F00] font-semibold" : ""
        }">${currencyFormatter.format(data.price)}</p>
                  ${data.isDiscounted
          ? `<p class="text-sm line-through">${currencyFormatter.format(
            data.compareAtPrice
          )}</p>`
          : ""
        }
                `
      }
            </div>
          </div>
        </div>
      </div>
  
      <cross-sell-drawer-button class="flex gap-1 items-center underline text-sm font-bold mt-3 cursor-pointer w-max">
        자세히 알아보기
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.36 7.52661L6.5867 3.75994C6.52472 3.69746 6.45099 3.64786 6.36975 3.61402C6.28851 3.58017 6.20137 3.56274 6.11336 3.56274C6.02535 3.56274 5.93822 3.58017 5.85698 3.61402C5.77574 3.64786 5.702 3.69746 5.64003 3.75994C5.51586 3.88485 5.44617 4.05382 5.44617 4.22994C5.44617 4.40607 5.51586 4.57503 5.64003 4.69994L8.94003 8.03328L5.64003 11.3333C5.51586 11.4582 5.44617 11.6272 5.44617 11.8033C5.44617 11.9794 5.51586 12.1484 5.64003 12.2733C5.70177 12.3363 5.7754 12.3864 5.85665 12.4207C5.9379 12.455 6.02516 12.4729 6.11336 12.4733C6.20157 12.4729 6.28882 12.455 6.37007 12.4207C6.45132 12.3864 6.52495 12.3363 6.5867 12.2733L10.36 8.50661C10.4277 8.44418 10.4817 8.36841 10.5186 8.28408C10.5556 8.19975 10.5747 8.10868 10.5747 8.01661C10.5747 7.92454 10.5556 7.83347 10.5186 7.74914C10.4817 7.66481 10.4277 7.58904 10.36 7.52661Z" fill="#2E2F3C"></path>
        </svg>
      </cross-sell-drawer-button>
    `;
  }
}

customElements.define("block-product-information", BlockProductInformation);

class BlockProductInformationV2 extends HTMLElement {
  constructor() {
    super();
    this.props = {
      type: "",
      title: "",
      image: "",
      handle: "",
      variants: [],
      subtitle: "",
    };
    this.state = { currentVariant: {} };
  }

  connectedCallback() {
    this.initProps();
    this.initState();
    this.render(this.getRenderData());
    if (this.props.type !== "FREEBIE") {
      ProductPageStore.subscribe((event) => {
        const currentVariant = this.getMatchedVariantSize();
        this.updateState({
          currentVariant: currentVariant
            ? currentVariant
            : this.props.variants[0],
        });

      });
    }

    this.attachCallback();
  }

  initProps() {
    this.props = {
      type: this.getAttribute(":type") ?? "",
      actionType: this.getAttribute(":action_type") ?? "drawer",
      title: this.getAttribute(":title"),
      image: this.getAttribute(":image"),
      handle: this.getAttribute(":handle"),
      variants: JSON.parse(this.getAttribute(":variants")),
      subtitle: this.getAttribute(":subtitle"),
    };
  }

  initState() {
    this.state = {
      currentVariant: this.getMatchedVariantSize()
        ? this.getMatchedVariantSize()
        : this.props.variants[0],
    };
  }

  updateState(updates) {
    this.state = { ...this.state, ...updates };
    this.render(this.getRenderData());
    this.attachCallback();
  }

  attachCallback() {
    this.querySelectorAll("cross-sell-drawer-button").forEach(
      (button) =>
      (button.handleOpenCrossSellDrawerFunction =
        this.handleCrossSellDrawerOpen.bind(this))
    );
  }

  getMatchedVariantSize() {
    const currentVariant = ProductPageStore.getState().currentVariant;
    if (!currentVariant) return this.props.variants[0];

    const size = currentVariant.title.split("(")[0].trim();
    const regex = new RegExp(String.raw`^${size}$`, "i");
    return this.props.variants.find((variant) =>
      regex.test(variant.title.split("(")[0].trim())
    );
  }

  handleCrossSellDrawerOpen() {
    if (
      this.props.actionType === "merge_pdp_tabs" &&
      document.querySelector("#joint-product-banners")
    ) {
      document
        .querySelector("#joint-product-banners")
        .scrollIntoView({ behavior: "smooth" });
      return;
    }

    window.eventBus.publish("cross-sell-drawer:open", {
      title: this.props.title.replace(" - BambooWeave", ""),
      subtitle: this.props.subtitle,
      drawerDescription: this.shadowRoot.querySelector(
        "cross-sell-drawer-description"
      ).innerHTML,
      image: this.props.image,
      link: "/products/" + this.props.handle,
      primaryButton: {
        text: "제품 보러가기",
        onClick: (state, closeDrawer) => {
          window.open(state.link, "_blank");
          closeDrawer();
        },
      },
      secondaryButton: {
        text: "쇼핑 계속하기",
        onClick: (state, closeDrawer) => {
          closeDrawer();
        },
      },
    });
  }

  getRenderData() {
    const result = {};
    result.title = this.props.title.replace(" - BambooWeave", "");
    result.price = this.state.currentVariant.price / 100;
    result.variantTitle = this.state.currentVariant.option1;
    result.compareAtPrice = this.state.currentVariant.compare_at_price / 100;
    result.image = this.props.image;
    result.isDiscounted =
      this.state.currentVariant.compare_at_price >
      this.state.currentVariant.price;
    result.discountPercentage = result.isDiscounted
      ? Math.round(
        ((this.state.currentVariant.compare_at_price -
          this.state.currentVariant.price) *
          100) /
        this.state.currentVariant.compare_at_price
      )
      : 0;
    result.isFreebie = this.props.type === "FREEBIE";
    result.isPillow = singleVariantProducts.includes(this.props.handle);
    return result;
  }

  render(data) {
    this.innerHTML = `
      <div class="flex items-center gap-3">
        <img src="${data.image
      }" width="50" height="50" class="rounded" loading="lazy" alt="">
        <div class="flex-1">
          <cross-sell-drawer-button class="font-semibold text-[14px] block cursor-pointer ">${data.title
      }</cross-sell-drawer-button>
          <div class="grow gap-0 md:gap-1 mt-0 md:mt-1 flex flex-col items-start mg:items-center">
          <p class="text-[#55576F] text-sm">Qty: 1</p>
            <div class="flex items-center gap-2">
              ${data.isFreebie
        ? `
                  <p class="md:flex justify-center items-center text-xs text-white font-bold max-w-max bg-[#FF8900] rounded p-1">FREE</p>
                  <p class="text-sm line-through">${currencyFormatter.format(
          data.price
        )}</p>
                `
        : `
                  <p class="md:flex justify-center items-center text-xs text-black font-bold max-w-max bg-[#FFCD4E] rounded p-1">무료</p>
                  <p class="text-sm ${data.isDiscounted ? "text-[#DA1F00] font-semibold" : ""
        }">${currencyFormatter.format(data.price)}</p>
                  ${data.isDiscounted
          ? `<p class="text-sm line-through">${currencyFormatter.format(
            data.compareAtPrice
          )}</p>`
          : ""
        }
                `
      }
            </div>
          </div>
        </div>
      </div>
  
      <cross-sell-drawer-button class="flex gap-1 items-center underline text-sm font-bold mt-3 cursor-pointer w-max">
        자세히 알아보기
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.36 7.52661L6.5867 3.75994C6.52472 3.69746 6.45099 3.64786 6.36975 3.61402C6.28851 3.58017 6.20137 3.56274 6.11336 3.56274C6.02535 3.56274 5.93822 3.58017 5.85698 3.61402C5.77574 3.64786 5.702 3.69746 5.64003 3.75994C5.51586 3.88485 5.44617 4.05382 5.44617 4.22994C5.44617 4.40607 5.51586 4.57503 5.64003 4.69994L8.94003 8.03328L5.64003 11.3333C5.51586 11.4582 5.44617 11.6272 5.44617 11.8033C5.44617 11.9794 5.51586 12.1484 5.64003 12.2733C5.70177 12.3363 5.7754 12.3864 5.85665 12.4207C5.9379 12.455 6.02516 12.4729 6.11336 12.4733C6.20157 12.4729 6.28882 12.455 6.37007 12.4207C6.45132 12.3864 6.52495 12.3363 6.5867 12.2733L10.36 8.50661C10.4277 8.44418 10.4817 8.36841 10.5186 8.28408C10.5556 8.19975 10.5747 8.10868 10.5747 8.01661C10.5747 7.92454 10.5556 7.83347 10.5186 7.74914C10.4817 7.66481 10.4277 7.58904 10.36 7.52661Z" fill="#2E2F3C"></path>
        </svg>
      </cross-sell-drawer-button>
    `;
  }
}

customElements.define("block-product-information-v2", BlockProductInformationV2);